const packageVersion = "0.2.0";
const Config = {
    DEBUG: false,
    LIB_VERSION: packageVersion,
    LIB_NAME: 'browser-common',
    JS_SDK_VERSION: packageVersion
};
const config = Config;
export { config as default };
